<template>
  <div :class="$route.path.split('/')">
    <div id="app">
      <router-view />
    </div>
    <!-- PC・レスポンシブ用の共通処理 -->
    <template v-if="common.device === 'pc' || common.device === 'public'">
      <transition name="popup">
        <PCSystemError v-if="common.systemError.show" />
      </transition>
      <transition name="popup">
        <PCSystemNotice v-if="common.notice.show" />
      </transition>
      <transition name="toast">
        <PCBasicToast v-if="common.toast.show">{{common.toast.text}}</PCBasicToast>
      </transition> 
      <transition name="popup">
        <PCLoading v-if="common.loading" />
      </transition>
    </template>
    <!-- SP用の共通処理 -->
    <template v-else-if="common.device === 'sp'">
      <transition name="popup">
        <SPSystemError v-if="common.systemError.show" />
      </transition>
      <transition name="popup">
        <SPSystemNotice v-if="common.notice.show" />
      </transition>
      <transition name="toast">
        <SPBasicToast v-if="common.toast.show">{{common.toast.text}}</SPBasicToast>
      </transition> 
      <transition name="popup">
        <SPLoading v-if="common.loading" />
      </transition>
    </template>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'
import store from '@/store'

import PCSystemError from '@/components/pc/partial/PCSystemError.vue'
import PCSystemNotice from '@/components/pc/partial/PCSystemNotice.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'
import PCLoading from '@/components/pc/partial/PCLoading.vue'

import SPSystemError from '@/components/sp/partial/SPSystemError.vue'
import SPSystemNotice from '@/components/sp/partial/SPSystemNotice.vue'
import SPBasicToast from '@/components/sp/popup/SPBasicToast.vue'
import SPLoading from '@/components/sp/partial/SPLoading.vue'

import { addEventListersForApp } from '@/util/app-event'

export default defineComponent({
  components: {
    PCSystemError,
    PCSystemNotice,
    PCBasicToast,
    PCLoading,
    SPSystemError,
    SPSystemNotice,
    SPBasicToast,
    SPLoading
  },
  setup (props, context) {
    const { common } = store.state

    onMounted(() => {
      document.documentElement.style.fontSize = 54.6875 + '%'
      document.documentElement.style.lineHeight = 1.5

      // アプリ全体でイベント監視するためのリスナーを追加する
      addEventListersForApp()
    })

    return {
      common
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
